import {UserProfile} from './userProfile';

export interface UserOptions {
    profile: UserProfile;
    username: string;
    email: string;
    password: string;
    confirmPassword: string;
    dbs?: Array<string>;
    _id?: string;
    _rev?: string;
  }

export class UserOptions implements UserOptions {
    profile = new UserProfile();
    username = '';
    email = '';
    password = '';
    confirmPassword = '';
    constructor(){}
  }
